<template>
  <Layout>
    <template v-slot:title>Mis Favoritos</template>

    <div class="max-w-screen-xl mx-auto">
      <FavoritesSocial class="ml-4" :videos-list="videosList" />

      <VideosList>
        En estos momentos no tienes seleccionado ningún vídeo como favorito.
      </VideosList>
    </div>
  </Layout>
</template>

<script>
import { mapState } from 'vuex'
import Layout from '@/layouts/MainLayout'
import VideosList from '@/components/VideosList'
import FavoritesSocial from '@/components/FavoritesSocial'

export default {
  components: { Layout, VideosList, FavoritesSocial },

  computed: {
    ...mapState('videos', ['videosList']),
  },

  mounted() {
    this.$store.dispatch('favorites/fetchFavoritesList')
  },
}
</script>
